import React, {Component} from 'react';

import ReactHighcharts from 'react-highcharts';

export default class ColumnChart extends Component {

    _getGraphConfig = () => {
        return {
            chart: {
                type: 'column',
                height:220,
                scrollablePlotArea: {
                    minWidth: this.props.data.length*40,
                    scrollPositionX: 0
                }
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: this.props.sections,
                crosshair: true,
                labels:{
                    style:{
                        fontWeight:600
                    }
                }

            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                }
            },
            credits:{
                enabled:false
            },
            legend:{
                enabled:false,
                layout: 'vertical',
                align: 'right',
                itemMarginBottom:15,
                itemStyle:{
                    fontWeight:500,
                    fontSize:13,
                    lineHeight:31,
                    fontFamily:"Arial",
                    color: '#585858'
                },
                verticalAlign: 'middle',
                floating: false,

            },

            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0"><b>{series.name}: </b></td>' +
                '<td style="padding:0"><b>{point.y:.0f}%</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    borderWidth: 0,
                    pointPadding:0,
                    pointWidth: 5
                }
            },
            series: this.props.data

        };
    }


    render() {

        let graph_config = this._getGraphConfig();

        return (
            <ReactHighcharts config={graph_config}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/profileFromPartnerCategory/components/columnChart/ColumnsChart.js